<template>
  <MainLayout :initialDrawerExpanded="false" contentClass="pa-0" :has-sidebar="false">
    <template #header>
      <div class="overline">
        <PageBack />
      </div>
    </template>

    <template #content>
      <SupportHero compact />
      <div class="pa-4">
        <div class="text-center mb-6">
          <h2 class="mb-3">Comment pouvons-nous vous aider ?</h2>
          <v-text-field
            v-model="q"
            placeholder="Rechercher dans la FAQ…"
            prepend-inner-icon="mdi-magnify"
            outlined dense clearable hide-details
            class="hero-search mx-auto"
            @keyup.enter="goSearch"
          />
        </div>
        <!-- Search results replace the home sections while typing -->
        <template v-if="q && q.trim()">
          <h2 class="mb-3">Résultats ({{ results.length }})</h2>
          <v-row v-if="results.length">
            <v-col v-for="item in results" :key="item.slug" cols="12" md="6">
              <FaqCard :item="item" show-category />
            </v-col>
          </v-row>
          <v-card v-else outlined class="pa-6 text-center">
            <p class="mb-3">Aucune réponse ne correspond à votre recherche.</p>
            <v-btn color="primary" elevation="0" @click="showNew = true">
              <v-icon left>mdi-plus</v-icon>Ouvrir un ticket
            </v-btn>
          </v-card>
        </template>

        <template v-else>
          <v-row>
            <v-col cols="12" md="8">
          <!-- Popular questions -->
          <div class="d-flex align-center mb-3">
            <h2>Questions fréquentes</h2>
            <v-spacer />
            <v-btn text color="primary" :to="{ name: 'faq' }">
              Tout voir<v-icon right small>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
          <v-row class="mb-4">
            <v-col v-for="item in featured" :key="item.slug" cols="12" lg="6">
              <FaqCard :item="item" show-category />
            </v-col>
          </v-row>

          <!-- Categories -->
          <h2 class="mb-3">Parcourir par thème</h2>
          <v-row>
            <v-col v-for="c in categories" :key="c.id" cols="6" sm="4">
              <v-card outlined hover class="fill-height text-center"
                :to="{ name: 'faq', query: { category: c.id } }">
                <v-card-text>
                  <v-icon large color="primary" class="mb-1">{{ c.icon }}</v-icon>
                  <div class="body-2 font-weight-medium text--primary">{{ c.title }}</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

            </v-col>
            <v-col cols="12" md="4">
              <TicketWidget />
            <div class="mt-4">
              <v-card outlined>
                <v-card-title class="subtitle-1 font-weight-medium">
                  <v-icon left color="primary">mdi-book-open-page-variant-outline</v-icon>Documentation
                </v-card-title>
                <v-list dense class="py-0">
                  <v-list-item v-for="d in docs" :key="d.to" :to="d.to">
                    <v-list-item-icon><v-icon>{{ d.icon }}</v-icon></v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ d.title }}</v-list-item-title>
                      <v-list-item-subtitle>{{ d.subtitle }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action><v-icon small>mdi-chevron-right</v-icon></v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-card>
            </div>
            </v-col>
          </v-row>
        </template>
      </div>
      <SupportNewDialog v-model="showNew" />
    </template>
  </MainLayout>
</template>

<script>
import PageBack from '@/components/ui/PageBack.vue'
import MainLayout from '@/layout/MainLayout.vue'
import SupportHero from '@/components/support/SupportHero.vue'
import FaqCard from '@/components/support/FaqCard.vue'
import TicketWidget from '@/components/support/TicketWidget.vue'
import SupportNewDialog from '@/components/support/SupportNewDialog.vue'
import { FAQ_CATEGORIES, featuredFaq, searchFaq } from '@/content/faq'

export default {
  name: 'SupportCenterView',
  components: { PageBack, SupportHero, MainLayout, FaqCard, TicketWidget, SupportNewDialog },
  data() {
    return {
      q: '',
      showNew: false,
      categories: FAQ_CATEGORIES,
      featured: featuredFaq(),
      // The old docs are kept as-is until they are reworked (see features/support.md).
      docs: [
        { to: '/manuel', icon: 'mdi-book-open-outline', title: 'Manuel utilisateur', subtitle: 'Guide complet de l\'application' },
        { to: '/help', icon: 'mdi-help-circle-outline', title: 'Aide (ancienne version)', subtitle: 'Aperçu des écrans — en cours de refonte' },
      ],
    }
  },
  computed: {
    results() {
      return searchFaq(this.q)
    },
  },
  methods: {
    /** Enter in the hero search opens the full FAQ list with the query. */
    goSearch() {
      if (this.q && this.q.trim()) this.$router.push({ name: 'faq', query: { q: this.q.trim() } })
    },
  },
}
</script>

<style scoped>
.hero-search {
  max-width: 560px;
}
</style>
